import { Stack, Typography, useMediaQuery, Button } from "@mui/material";
import { useAuth } from "../Auth/State/AuthContext";
import Keycloak from "../Auth/Keycloak";
import { ACCESO_DIFUSIONES } from "../Contantes/Constantes"
import Avatar from "@mui/material/Avatar";
import React from "react";
import KeyCloak from "../Auth/Keycloak";
import { useBody } from "./state/BodyContext";
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';

export default function Banner() {
  const matches = useMediaQuery("(min-width:800px)");
  const { user, isLogedIn, hasRole } = useAuth();
  const { googleImageBase64 } = useBody();
  const [userInfo, setUserInfo] = React.useState({
    username: '',
    name: ''
  });

  React.useEffect(() => {
    if (KeyCloak.isLoggedIn() && isLogedIn()) {
      setUserInfo(prevState => ({
        ...prevState,
        username: user.uid,
        name: user.name
      }));
    }
  }, [user, isLogedIn]);

  return (
    <>
      <Stack
        sx={{
          alignContent: "center",
          justifyContent: "center",
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.8)), url(/banner.jpg)`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          height: "350px",
          color: "#d5d5d5",
          boxShadow:
            "rgba(0, 0, 0, 0.2) 0px 2px 4px -1px, rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px",
        }}
      >
        <Stack
          sx={{
            textAlign: "center",
            alignItems: "center",
            justifyContent: "center",
            gap: "15px",
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontWeight: "700",
              fontSize: matches ? "35px" : "30px",
              paddingX: "20px",
            }}
          >
            ¡Bienvenido{user.name ? ' ' + user.name : ''}!
          </Typography>
          {(KeyCloak.isLoggedIn() && isLogedIn() && googleImageBase64 === null) && (
            <Avatar sx={{ width: '8vh', height: '8vh', fontSize: '4vh' }}>
              {userInfo.username.charAt(0).toUpperCase()}
            </Avatar>
          )}
          {(KeyCloak.isLoggedIn() && isLogedIn() && googleImageBase64 !== null) && (
            <Avatar
              sx={{ width: '8vh', height: '8vh' }}
              src={`data:image/;base64,  ${googleImageBase64}`}
            />
          )}
          <Typography
            variant="h6"
            sx={{
              maxWidth: "600px",
              padding: "20px",
              fontWeight: matches ? "bold" : "600",
              fontSize: matches ? "19px" : "16px",
            }}
          >
            Se encuentra en el portal de acceso a los servicios que provee la
            Secretaría de Tecnologías de la Información y la Comunicación de la
            UTN FRBA
          </Typography>
          {isLogedIn() ? null :
            <Button
              onClick={Keycloak.doFirstLogin}
              size='large'
              sx={{
                borderRadius: '20px',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat'
              }}
              variant='contained'
              color='primary'
            >
              Iniciar sesión
            </Button>
          }
        </Stack>
      </Stack>

      <div style={{
          backgroundColor: "#e0f7fa",
          width: "100%",
          textAlign: "center",
          fontSize: "16px",
          padding: "12px",
          marginTop: "7px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "8px",
          fontWeight: "bold",
          color: "#006064",
          marginBottom: 3
        }}>
        <PhoneIphoneIcon />
        ¡SIA ahora es 100% funcional desde tu celular!
      </div>
    </>
  );
}
